export default "__VITE_ASSET__DwOA4q2v__"